import React from "react";
import "../../City/CityInfo/style.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {  Button } from "react-bootstrap";
// Form, FormControl, ToggleButtonGroup, ToggleButton,
// import PKButton from "components/Button/Button";
// import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
//import SocialMedia from "pages/City/CityInfo/SocialMedia";
//import CityAdmin from "pages/City/CityInfo/CityAdmin";
// import PlaceholderImage from "Assets/present-img.png";
// import { BlockPicker } from 'react-color';
//import { apiUrl, myHeaders_Autorized, HeaderConfig,events_list_api, channel_list_api, myHeaders_With_Cache_Control } from "Api/Api";
import { searchUrl, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , myHeaders_With_Cache_Control, myHeaders_Authorized, apiUrl,
import axios from 'axios';
// import { NavLink } from "react-router-dom";
// import { local_routes } from 'utils/Routes';
// import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
// import Select from 'react-select';
// import MultipleImagesUpload from 'components/MultipleImagesUpload/MultipleImagesUpload';

import moment from 'moment-timezone';
import {Line,defaults} from 'react-chartjs-2'

defaults.animation = false;

class PechaKuchaStats extends React.Component {
  constructor(props) {
      super(props);
      this.state = {
        //tophat_info: {},
        //youtube_info: {},
        //youtube_uuid: null,
        //update_loading: false,
        //homepage_banner_images_uuid: null,
        //tophat_uuid: null,
        //banner_image_urls_array: [],
        //local_file_image_array: [],
        stats: [],
        loading: true,
        message: null,
				chartLabels: [],
				verifiedUserData: [],
				rawUserData: [],
				presentationData: []
      };
      
      //this.max_banner_images = 20;
      
  }

  componentDidMount = async function () {
      this.getFromApi();
      let newChartStats = await this.graphStatsApi()
			await this.setChartData(newChartStats)
  }

  getFromApi = async () => {
    this.setState({ loading: true, message: null });
    //let new_state = {...this.state};
    console.log("PechaKuchaStats getFromApi");
    /*
    let date = new Date.UTC();
    let unixtime_now = Math.floor(date.getTime() / 1000);
    let last_month_start = Math.floor(new Date(date.getFullYear(), date.getMonth()-1, 0).getTime() / 1000);
    let last_month_end = Math.floor(new Date(date.getFullYear(), date.getMonth(), 0).getTime() / 1000);
    
    let this_month_string = (date.getMonth()+1)+'/'+date.getFullYear();
    date.setMonth(date.getMonth()-1);
    let last_month_string = (date.getMonth()+1)+'/'+date.getFullYear();
    */
    let moment_date_now = moment.utc();
    let moment_date_last_month = moment.utc().subtract(1,'month');
    let unixtime_now = moment_date_now.unix();

    let this_month_string = (moment_date_now.month()+1)+'/'+moment_date_now.year();
    let last_month_string = (moment_date_last_month.month()+1)+'/'+moment_date_last_month.year();

    let last_month_start = moment_date_last_month.startOf('month').unix();
    let last_month_end = moment_date_now.startOf('month').unix();
    
    let stats = [
      {
        label: 'This Month ('+this_month_string+')',
        query_types: [
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              status_code: 1,
              created_time_start: last_month_end,
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Verified Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              all_statuses: true,
              created_time_start: last_month_end,
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Raw Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'presentations',
              status_code: 1,
              created_time_start: last_month_end,
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Published Presentations'
          }
        ]
      },
      {
        label: 'Last Month ('+last_month_string+')',
        query_types: [
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              status_code: 1,
              created_time_start: last_month_start,
              created_time_end: last_month_end
            },
            count: 0,
            label: 'New Verified Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              all_statuses: true,
              created_time_start: last_month_start,
              created_time_end: last_month_end
            },
            count: 0,
            label: 'New Raw Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'presentations',
              status_code: 1,
              created_time_start: last_month_start,
              created_time_end: last_month_end
            },
            count: 0,
            label: 'New Published Presentations'
          }
        ]
      },
      {
        label: 'Past 24 Hours',
        query_types: [
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              status_code: 1,
              created_time_start: unixtime_now - 86400,
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Verified Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              all_statuses: true,
              created_time_start: unixtime_now - 86400,
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Raw Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'presentations',
              status_code: 1,
              created_time_start: unixtime_now - 86400,
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Published Presentations'
          }
        ]
      },
      {
        label: 'Past 30 Days',
        query_types: [
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              status_code: 1,
              created_time_start: unixtime_now - (86400 * 30),
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Verified Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              all_statuses: true,
              created_time_start: unixtime_now - (86400 * 30),
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Raw Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'presentations',
              status_code: 1,
              created_time_start: unixtime_now - (86400 * 30),
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Published Presentations'
          }
        ]
      },
      {
        label: 'Past 365 Days',
        query_types: [
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              status_code: 1,
              created_time_start: unixtime_now - (86400 * 365),
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Verified Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'users',
              all_statuses: true,
              created_time_start: unixtime_now - (86400 * 365),
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Raw Users'
          },
          {
            params: {
              count_only: true,
              q: 'all',
              entity_type: 'presentations',
              status_code: 1,
              created_time_start: unixtime_now - (86400 * 365),
              created_time_end: unixtime_now
            },
            count: 0,
            label: 'New Published Presentations'
          }
        ]
      }
    ];
    let api_promises = [];
    let api_promises_info = [];
    stats.forEach ((timeframe_obj,timeframe_index) => {
      timeframe_obj.query_types.forEach ((query_type_obj,query_type_index) => {
        api_promises.push(axios.get(`${searchUrl}sitesearch`, { params: query_type_obj.params, ...myHeaders_Auth_With_Cache_Control }));
        api_promises_info.push({timeframe_index,query_type_index});
      });
    });
    try {
      let api_promises_values = await Promise.all(api_promises);
      api_promises_values.forEach ((api_response,index) => {
        if (api_response.data && api_response.data.additional_information && api_response.data.additional_information.total_search_results >= 0) {
          let timeframe_index = api_promises_info[index].timeframe_index;
          let query_type_index = api_promises_info[index].query_type_index;
          stats[timeframe_index].query_types[query_type_index].count = api_response.data.additional_information.total_search_results;
          console.log("FOUND",api_response.data.additional_information.total_search_results)
        }          
      });
      let last_updated_date = new Date().toLocaleString();
      this.setState({stats,loading:false,message:'Last Updated: '+last_updated_date});
    } catch (err) {
      console.error("Something wrong!",err);
      this.setState({stats:[],loading:false,message:'ERROR!'});
      return;
    }
  }

  graphStatsApi = async () => {
    let months = [];
    for (let i = 0; i < 12; i++) {
     let currentMonthStart = moment().subtract(i,'months');
		 let monthName = currentMonthStart.format('MMM')
     let currentMonthEnd = moment().subtract(i,'months');
     let startTime = currentMonthStart.startOf('month').unix();
     let endTime = currentMonthEnd.endOf('month').unix();
     months.push({startTime,endTime,monthName});
    }
    let chartStats = [];
    months.forEach((month) => {
     chartStats.push({
			label: month.monthName,
				query_types: [
					{
						params: {
							count_only: true,
							q: 'all',
							entity_type: 'users',
							status_code: 1,
							created_time_start: month.startTime,
							created_time_end: month.endTime
						},
						count: 0,
						label: 'New Verified Users'
					},
					{
						params: {
							count_only: true,
							q: 'all',
							entity_type: 'users',
							all_statuses: true,
							created_time_start: month.startTime,
							created_time_end: month.endTime
						},
						count: 0,
						label: 'New Raw Users'
					},
					{
						params: {
							count_only: true,
							q: 'all',
							entity_type: 'presentations',
							status_code: 1,
							created_time_start: month.startTime,
							created_time_end: month.endTime
						},
						count: 0,
						label: 'New Published Presentations'
					}
				]
			});
    });
		let apiPromises = []
		let apiPromisesInfo =[]
    chartStats.forEach((monthObj, monthIndex)=>{
			monthObj.query_types.forEach((queryTypeObj, queryTypeIndex)=>{
				apiPromises.push(axios.get(`${searchUrl}sitesearch`, {params: queryTypeObj.params, ...myHeaders_Auth_With_Cache_Control}));
				apiPromisesInfo.push({monthIndex, queryTypeIndex});
			});
		});
		try{
			let apiPromisesValues = await Promise.all(apiPromises)
			apiPromisesValues.forEach((response, index) =>{
				if (response.data && response.data.additional_information && response.data.additional_information.total_search_results >= 0){
					let timeframeIndex = apiPromisesInfo[index].monthIndex
					let queryTypeIndex = apiPromisesInfo[index].queryTypeIndex
					chartStats[timeframeIndex].query_types[queryTypeIndex].count = response.data.additional_information.total_search_results
				}
			})
			let newChartStats = chartStats.reverse()
			return newChartStats
		}catch (err){
			console.log("Something is wrong!!", err)
		} 
  }
  
	setChartData = (chartStats) => {
		let monthLabels = []
		let verifiedUserArr = []
		let rawUserArr = []
		let presentationArr = []
		chartStats.forEach((stat)=>{
			monthLabels.push(stat.label)
			verifiedUserArr.push(stat.query_types[0].count)
			rawUserArr.push(stat.query_types[1].count)
			presentationArr.push(stat.query_types[2].count)
		})
		this.setState({chartLabels: monthLabels, verifiedUserData: verifiedUserArr, rawUserData: rawUserArr, presentationData: presentationArr })
	}
	displayChartData = () =>{
		let data = {
			labels: this.state.chartLabels,
			datasets: [
				{
					label: 'New Verified Users',
					data: this.state.verifiedUserData,
					fill: false,
					backgroundColor: 'rgba(53, 153, 23, 0.3)',
					borderColor: 'rgb(53, 153, 23)'
				},
				{
					label: 'New Raw Users',
					data: this.state.rawUserData,
					fill: false,
					backgroundColor: 'rgba(30, 50, 230, 0.3)',
					borderColor: 'rgb(30, 50, 230)'
				},
				{
				label: 'New Published Presentations',
				data: this.state.presentationData,
				fill: false,
				backgroundColor: 'rgba(212, 0, 71, 0.3)',
				borderColor: 'rgb(212, 0, 71)'
			},
			],
		};
		return data
	}

  renderStatsBlock = (query_types) => {
    let contents = [];
    query_types.forEach((query_type,index) => {
      contents.push(this.renderStats(query_type,index));
    });
    return contents;
  }


  renderStats = (stats_item, index) => {

    return (
      <Row key={index}>
        <Col xs={8}>
          {stats_item.label}
        </Col>
        <Col xs={4}>
          {stats_item.count}
        </Col>
      </Row>      
    );
    
    
  }

    render() {
      /*        
      if (this.state.loading) {
          return (
              <div className="createEventSpinner">
                  <ActivityIndicator theme="spinner" />
              </div>
          );
      }
      */
        return (
            <div className="city-info">
              <div className="container pad-bot30">
                <Row className="pad-top30 pad-bot10 editCity">
                    <Col lg={6} md={6} sm={6} className="pad0" >
                        <h1>PechaKucha Stats</h1>
                        <span style={{ fontSize: 'smaller', fontStyle: 'italic' }}>All statistics are stored and shown in UTC</span>
                    </Col>
                    <Col lg={6} md={6} sm={6} className="pad0" >
                        <div className="cityUpdate-btn">
                          <Button
                            disabled={this.state.loading}
                            variant="pkprimary"
                            onClick={this.getFromApi}
                          >
                            Refresh
                          </Button>
                        </div>
                     </Col>
                </Row>
								{(this.state.chartLabels.length<1)?(<ActivityIndicator/>):(
									<Line data={this.displayChartData}/> 
								)}
                
                { this.state.message &&
                  <Row style={{ marginBottom: "10px" }}>
                    {this.state.message}
                  </Row>
                }
                
                { !this.state.loading ?
                  <React.Fragment>
                    { this.state.stats.map( (timeframe_obj,timeframe_index) => (
                      <Row key={timeframe_index} style={{ padding: '5px', border: "1px solid #d8d8d8", marginBottom: "30px" }}>
                        <Col xs={12}>
                          <h3>{timeframe_obj.label}</h3>
                          { this.renderStatsBlock( timeframe_obj.query_types ) }
                        </Col>
                      </Row>
                    ))}
                  </React.Fragment>
                  :
                  <div className="createEventSpinner">
                      <ActivityIndicator theme="spinner" />
                  </div>                  
                }
              </div>
            </div>
        );
        

    }
}

export default PechaKuchaStats;
